import React from 'react';

interface IconPrintProps {
    iconClasses?: string;
}

const IconPrint: React.FC<IconPrintProps> = ({ iconClasses }) => {
    return (
        <svg
            width="12"
            height="11"
            viewBox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-print ${iconClasses ?? ''}`}
        >
            <path
                d="M10.2 3.05556H1.8C0.804 3.05556 0 3.87444 0 4.88889V7.33333C0 8.00556 0.54 8.55556 1.2 8.55556H2.4V9.77778C2.4 10.45 2.94 11 3.6 11H8.4C9.06 11 9.6 10.45 9.6 9.77778V8.55556H10.8C11.46 8.55556 12 8.00556 12 7.33333V4.88889C12 3.87444 11.196 3.05556 10.2 3.05556ZM7.8 9.77778H4.2C3.87 9.77778 3.6 9.50278 3.6 9.16667V6.72222H8.4V9.16667C8.4 9.50278 8.13 9.77778 7.8 9.77778ZM10.2 5.5C9.87 5.5 9.6 5.225 9.6 4.88889C9.6 4.55278 9.87 4.27778 10.2 4.27778C10.53 4.27778 10.8 4.55278 10.8 4.88889C10.8 5.225 10.53 5.5 10.2 5.5ZM9 0H3C2.67 0 2.4 0.275 2.4 0.611111V1.83333C2.4 2.16944 2.67 2.44444 3 2.44444H9C9.33 2.44444 9.6 2.16944 9.6 1.83333V0.611111C9.6 0.275 9.33 0 9 0Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconPrint;
